import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { filter, map, switchMap } from 'rxjs';

import { AuthorisationService } from '@common/service/authorisation.service';
import { NotificationService } from '@common/service/notification.service';
import { UserQuery } from '@common/store/user.store';
import { isEmpty } from '@common/util/util';

export const editorPermissionGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthorisationService);
  const userQuery = inject(UserQuery);
  const notificationService = inject(NotificationService);

  return userQuery.user$.pipe(
    filter((user) => !isEmpty(user)),
    switchMap(() => {
      return authService.hasWritePermission$.pipe(
        map((canUseEditor) => {
          if (!canUseEditor) {
            notificationService.notify({
              message: 'Unauthorised',
              duration: 5000,
            });

            router.navigate(['/modules']);
            return false;
          }

          return true;
        }),
      );
    }),
  );
};
